import { ModelBase } from 'store/model-base';
import { GtpSessionState } from 'my-account/constants';

export class GtpSession extends ModelBase {
    public static storeName: string = 'gtpSession';

    public countryCode: string;
    public startTime: string;
    public endTime: string;
    public status: GtpSessionState;
}
